import { ContentReference } from '@cfa/pathway-fe-shared/xp';
import { Tabs } from '@cfa/react-core';

import { COUNTRIES } from '@/utils/document-utils/countries';
import { cn } from '@/utils/tailwind';

interface ChooseDocumentCountryTabsProps {
  activeCountryTab?: string;
  countryHasResource: string[];
  onCountryTabChange: (country: ContentReference['country']) => void;
}

const ChooseDocumentCountryTabs = ({
  activeCountryTab,
  countryHasResource,
  onCountryTabChange,
}: ChooseDocumentCountryTabsProps) => {
  const activeTabKey = activeCountryTab ?? countryHasResource[0] ?? '';

  const handleChange = (tab: string) => {
    onCountryTabChange(tab as ContentReference['country']);
  };

  if (countryHasResource.length <= 1) {
    return null;
  }

  return (
    <div className="shadow-elevation-6 -mx-4 mb-8 w-[calc(100%+32px)] md:-mx-8 md:w-[calc(100%+64px)]">
      <Tabs.Root
        selectedKey={activeTabKey}
        color="secondary"
        onSelectionChange={key => handleChange(String(key))}
        className="border-grayscale-gray2 box-border border-b px-8"
      >
        <Tabs.List>
          {COUNTRIES.filter(({ id }) => countryHasResource.includes(id)).map(
            ({ id, label }) => (
              <Tabs.Item
                key={id}
                id={id}
                className={cn('mt-1.5! mb-5! cursor-pointer! px-8!')}
              >
                {label ?? id}
              </Tabs.Item>
            ),
          )}
        </Tabs.List>
      </Tabs.Root>
    </div>
  );
};

export default ChooseDocumentCountryTabs;
